export default __webpack_public_path__ + "static/fitco_white_logo-5c3316907ddfd32b0fab674ba919a4cd.png";